<template>
  <div class="container">
    <!-- 面包屑导航 -->
    <div class="breadcrumb">
      <navbar></navbar>
    </div>
    <div class="content page-title">
      <h2>固定推送</h2>
    </div>
    <div class="content">
      <h3>APP、H5站内信推送模板</h3>
      <h4>粉丝新增模板</h4>
      <div>
        <el-form :inline="true" :model="sInsideForm" ref="sInsideForm" class="template-operation" size="small" v-if="templateForFans.paramList">
          <el-form-item label="" prop="name">
            <el-input v-model="templateForFans.paramList[0].paramContent" placeholder="请输入" clearable ></el-input>
          </el-form-item>
          <el-form-item label="" prop="status">
            <el-select v-model="templateForFans.paramList[1].paramContent" placeholder="请选择用户昵称">
              <el-option
                  v-for="item in dictionaries.message_customer_user_info2"
                  :key="item.dictId"
                  :label="item.dictName"
                  :value="item.dictId"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="" prop="name1">
            <el-input v-model="templateForFans.paramList[2].paramContent" placeholder="请输入" clearable maxlength="30" show-word-limit></el-input>
          </el-form-item>
          <el-form-item class="form-operation-but">
            <el-button type="danger" @click="siteInsideMsgEnable(templateForFans.status)" v-if="templateForFans.status === 1">停用</el-button>
            <el-button type="primary" @click="siteInsideMsgEnable(templateForFans.status)" v-else>开启</el-button>
          </el-form-item>
        </el-form>
        <div class="operation-but">
          <el-button type="primary" @click="siteInsideMsgSave()">保存</el-button>
          <el-button type="primary" class="reset" @click="siteInsideMsgSelectList('opt')">重置</el-button>
        </div>
      </div>
    </div>
    <div class="content table">
      <h3><label>第三方模板列表</label>
        <!--        <span class="sync-but" @click="refreshTemplate()"><i class="el-icon-refresh"></i>同步模板数据</span>-->
      </h3>
      <h4><label>{{ fans.title }}</label><el-button type="primary" plain @click="showDialog('add')" class="template-add">新增模板动作</el-button></h4>
      <push-table :typeStr="fans.type" :list="fans.page.list" :config="fans.config" @onOperation="actionOperation"></push-table>
    </div>
    <div class="content table">
      <h4><label>{{miniProgram.title}}</label><!--<el-button type="primary" plain @click="showDialog('add')" class="template-add">新增模板动作</el-button>--></h4>
      <push-table v-loading="miniProgram.loading" :typeStr="miniProgram.type" :list="miniProgram.page.list" :config="miniProgram.config" @onOperation="actionOperation"></push-table>
    </div>
    <div class="content table">
      <h4><label>{{ weixin.title }}</label><!--<el-button type="primary" plain @click="showDialog('add')" class="template-add">新增模板动作</el-button>--></h4>
      <push-table v-loading="weixin.loading" :typeStr="weixin.type" :list="weixin.page.list" :config="weixin.config" @onOperation="actionOperation"></push-table>
    </div>

    <!--========================== el-dialog =================================-->
    <el-dialog
        :title="dialog.title"
        :visible.sync="dialog.visible"
        :width="dialog.width"
        :append-to-body="true"
        :custom-class="dialog.type === 'modifyState'? 'modify-state' : ''"
    >
      <template>
        <el-form :model="templateForm" :rules="rules" ref="templateForm" label-width="110px" class="dialog-form">

          <el-form-item label="模板动作" prop="name" v-if="dialog.type === 'add'">
            <el-select v-model="templateForm.name" placeholder="请选择模板动作">
              <el-option label="粉丝关注" value="粉丝关注"></el-option>
            </el-select>
          </el-form-item>
<!--
          <el-form-item label="模板动作" prop="name" v-if="dialog.type === 'add'">
            <el-input
                placeholder="请输入模板标题"
                clearable
                :maxlength="20"
                v-model="templateForm.name"
            ></el-input>
          </el-form-item>
-->
          <el-form-item label="模板" prop="templateId">
            <el-select v-model="templateForm.templateId" clearable filterable placeholder="请选择模板" @change="onChangeTempl">
              <el-option
                  v-for="item in templateDataList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
              >
              </el-option>
            </el-select>
            <div>{{templateContent}}</div>
          </el-form-item>

          <template v-for="(pItem, pIndex) in templateForm.paramList" >
            <el-form-item label="参数" prop="paramList" :key="pIndex" v-if="templateForm.paramList.length > 0">
              <span slot="label" v-if="templateForm.paramList.length > 1">参数{{pIndex+1}}</span>
              <span slot="label" v-else>参数</span>
              <el-select v-model="templateForm.paramList[pIndex].paramContent" clearable filterable placeholder="请选择参数">
                <el-option
                    v-for="(item, index) in dictionaries.message_customer_user_info"
                    :key="item.dictId"
                    :label="item.dictName"
                    :value="item.dictId"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </template>

          <el-form-item label="模板签名" prop="signType">
            <el-select v-model="templateForm.signType" filterable placeholder="请选择模板签名">
              <el-option
                  v-for="item in dictionaries.teng_xun_sign"
                  :key="item.dictId"
                  :label="item.dictName"
                  :value="item.dictId"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </template>

      <div slot="footer" class="dialog-footer">
        <el-button @click="centerDialog">取 消</el-button>
        <el-button type="primary" @click="submitDialog">保 存</el-button>
      </div>

    </el-dialog>

  </div>
</template>

<script>
import common from './mixins/common'
import navbar from '@/components/navbar.vue'
import PushTable from './components/PushTable.vue'
import Label from '@/pages/examination/label.vue'
export default {
  // mixins: [common],
  components: { Label, navbar, PushTable },
  watch: {
    /*
    dialog: {
      handler (newVal, oldVal) {
        if (newVal.type === 'set') {
          this.getSettingUp()
        }
      },
      deep: true
    }
    */
  },
  data () {
    return {
      dictionaries: { // 字典数据
        enable_status: [], // 状态字典 （1-启用，2-禁用）
        teng_xun_sign: [], // 模板签名
        message_customer_user_info: [], // 参数内容
        message_customer_user_info2: [], // 参数内容
        message_object_type: [], // 发送对象类型
        message_type: [], // 发送方式
        message_status: [] // 发送状态
      },
      templateForFans: {}, // 粉丝新增模板
      templateDataList: [],
      messageActionSettingList: [],
      sInsideForm: { aaa: '', bbb: '', ccc: '' },
      dialog: { visible: false, title: '编辑', type: '', row: {}, list: [], batch: false, titleArr: [] },
      // page: { pageNo: 1, pageSize: 2, totalNum: 0, currentPage: 1, list: [], status: '' },
      fans: {
        loading: false,
        title: '短信推送模板',
        type: 'fans',
        config: [
          { type: 'index', label: '序号', width: 60 },
          { prop: 'name', label: '模板动作', align: 'left', width: 100 },
          { prop: 'templateName', label: '模板', align: 'left', width: 100 },
          { prop: 'param', label: '参数', align: 'center', width: 100 },
          { prop: 'signType', label: '模板签名', align: 'center', width: 100 },
          { prop: 'content', label: '内容', align: 'center', width: 100 },
          { prop: 'createdTime', label: '创建时间', width: 100 },
          { prop: 'operation', slot: 'operation', label: '操作', width: 100 }
        ],
        page: { pageNo: 1, pageSize: 100, totalNum: 0, currentPage: 1, list: [], status: '' }
      },
      miniProgram: {
        loading: false,
        title: '小程序推送模板',
        type: 'miniProgram',
        config: [
          { type: 'index', label: '序号', width: 60 },
          { prop: 'title', label: '模板标题', align: 'left', width: 100 },
          { prop: 'example', label: '模板关键词', align: 'left', width: 100 },
          { prop: 'priTmplId', label: '模板ID', align: 'center', width: 100 },
          { prop: 'type', label: '模板类型', align: 'center', width: 100 },
          { prop: 'status', label: '状态', width: 100, slot: 'state' },
          { prop: 'createdTime', label: '创建时间', width: 100 },
          { prop: 'operation', slot: 'operation', label: '操作', width: 100 }
        ],
        page: { pageNo: 1, pageSize: 100, totalNum: 0, currentPage: 1, list: [], status: '' }
      },
      weixin: {
        loading: false,
        title: '公众号推送模板',
        type: 'weixin',
        config: [
          { type: 'index', label: '序号', width: 60 },
          { prop: 'title', label: '模板标题', align: 'left', width: 100 },
          { prop: 'content', label: '消息正文', align: 'left', width: 100 },
          { prop: 'templateId', label: '模板ID', align: 'center', width: 100 },
          { prop: 'status', label: '状态', width: 100, slot: 'state' },
          { prop: 'createdTime', label: '创建时间', width: 100 },
          { prop: 'operation', slot: 'operation', label: '操作', width: 100 }
        ],
        page: { pageNo: 1, pageSize: 100, totalNum: 0, currentPage: 1, list: [], status: '' }
      },
      templateContent: '',
      templateForm: {
        name: '粉丝关注', // 模板标题
        templateId: '', // 模板
        signType: '', // 模板签名
        // paramList: [{ paramType: '1', paramContent: '' }]
        paramList: []
      },
      rules: {
        name: [{ required: true, message: '请选择模板标题', trigger: 'change' }],
        templateId: [{ required: true, message: '请选择模板', trigger: 'change' }],
        signType: [{ required: true, message: '请选择模板签名', trigger: 'change' }],
        paramList: [{ type: 'array', required: true, message: '请选择模板参数', trigger: 'change' }]
      }

    }
  },
  mounted () {},
  created () {
    this.siteInsideMsgSelectList()
    this.fetchTemplateDataList()
    // this.fetchMessageActionSettingList()
    this.fetchMessageData()
    this.fetchMiniData()
    this.fetchWeixinData()
    for (const type in this.dictionaries) { this.getDictionaries(type) }
  },
  methods: {
    getDictionaries (type) {
      return new Promise(resolve => {
        if (type && this.dictionaries[type].length > 0) { return }
        const params = { groupId: type }
        this.$api.dictionaries(params).then((res) => {
          this.dictionaries[type] = res.data
          resolve(res.data)
        }).catch((err) => {
          console.log(err)
        })
      })
    },
    fetchTemplateDataList () {
      const params = {}
      this.$api.jhyxTemplateDataList(params).then((res) => {
        if (res.code === 0) {
          this.templateDataList = res.data
        } else {
          console.log('allMiniTemplate - 失败', res)
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    fetchMessageActionSettingList () {
      const params = {}
      this.$api.selectJhyxMessageActionSettingList(params).then((res) => {
        if (res.code === 0) {
          this.messageActionSettingList = res.data
        } else {
          console.log('allMiniTemplate - 失败', res)
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    refreshTemplate () {
      const params = {}
      this.$api.refreshJhyxTemplate(params).then((res) => {
        if (res.code === 0) {
          this.$message.success('刷新消息模板成功！')
        } else {
          console.log('refreshTemplate - 失败', res)
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    fetchMessageData (type) {
      this.fans.loading = true
      const params = {
        pageNo: this.fans.page.pageNo,
        pageSize: this.fans.page.pageSize,
        status: this.fans.page.status
      }
      this.$api.selectJhyxMessageActionSettingList(params).then((res) => {
        if (res.code === 0) {
          this.fans.page.list = res.data.list
        } else {
          console.log('allMiniTemplate - 失败', res)
        }
        this.fans.loading = false
      }).catch((err) => {
        this.fans.loading = false
        console.log(err)
      })
    },
    fetchMiniData (type) {
      this.miniProgram.loading = true
      const params = {
        pageNo: this.miniProgram.page.pageNo,
        pageSize: this.miniProgram.page.pageSize,
        status: this.miniProgram.page.status
      }
      this.$api.allMiniTemplate(params).then((res) => {
        if (res.code === 0) {
          res.data.forEach(e => {
            if (e.type === 2) { e.type = '一次性订阅' }
          })
          this.miniProgram.page.list = res.data
        } else {
          console.log('allMiniTemplate - 失败', res)
        }
        this.miniProgram.loading = false
      }).catch((err) => {
        this.miniProgram.loading = false
        console.log(err)
      })
    },
    fetchWeixinData (type) {
      this.weixin.loading = true
      const params = {
        pageNo: this.weixin.page.pageNo,
        pageSize: this.weixin.page.pageSize,
        status: this.weixin.page.status
      }
      this.$api.allPrivateTemplate(params).then((res) => {
        if (res.code === 0) {
          this.weixin.page.list = res.data
        } else {
          console.log('allMiniTemplate - 失败', res)
        }
        this.weixin.loading = false
      }).catch((err) => {
        this.weixin.loading = false
        console.log(err)
      })
    },

    actionOperation (e) {
      const { type, oType, row } = e
      switch (oType) {
        case 'edit':
          this.getmaDetail(e)
          // console.log('actionOperation 编辑')
          break
        case 'enable':
          this.onEnable(type, row)
          break
        default: // disable
          this.onDisable(type, row)
      }
    },
    onEnable (type, row) {
      const params = { status: 1 }
      let actionFun = ''
      switch (type) {
        case 'fans':
          // params['priTmplId'] = row.priTmplId
          params['id'] = row.id
          actionFun = this.$api.enableJhyxMessageActionSetting
          break
        case 'miniProgram':
          // params['priTmplId'] = row.priTmplId
          params['templateId'] = row.priTmplId
          actionFun = this.$api.wxMiniTemplateUpdate
          break
        default: // disable
          params['templateId'] = row.templateId
          actionFun = this.$api.wxH5TemplateUpdate
      }

      this.$confirm('是否继续操作?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        actionFun(params).then((res) => {
          if (res.code === 0) {
            this.$message.success('操作成功！')
            switch (type) {
              case 'fans':
                this.fetchMessageData()
                break
              case 'miniProgram':
                this.fetchMiniData()
                break
              default: // weixin
                this.fetchWeixinData()
            }
          } else {
            console.log(`${actionFun}-失败`, res)
          }
        }).catch((err) => {
          console.log(err)
        })
      }).catch((err) => {
        this.$message({
          type: 'info',
          message: '已取消操作'
        })
      })
    },
    onDisable (type, row) {
      const params = { status: 2 }
      let actionFun = ''
      switch (type) {
        case 'fans':
          // params['priTmplId'] = row.priTmplId
          params['id'] = row.id
          actionFun = this.$api.enableJhyxMessageActionSetting
          break
        case 'miniProgram':
          params['templateId'] = row.priTmplId
          actionFun = this.$api.wxMiniTemplateUpdate
          break
        default: // disable
          params['templateId'] = row.templateId
          actionFun = this.$api.wxH5TemplateUpdate
      }

      this.$confirm('是否继续操作?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        actionFun(params).then((res) => {
          if (res.code === 0) {
            this.$message.success('操作成功！')
            switch (type) {
              case 'fans':
                this.fetchMessageData()
                break
              case 'miniProgram':
                this.fetchMiniData()
                break
              default: // weixin
                this.fetchWeixinData()
            }
          } else {
            console.log(`失败`, res)
          }
        }).catch((err) => {
          console.log(err)
        })
      }).catch((err) => {
        this.$message({
          type: 'info',
          message: '已取消操作'
        })
      })
    },
    getmaDetail (e) {
      const { type, oType, row } = e
      const params = { id: row.id }
      this.$api.getJhyxMessageActionSettingDetail(params).then((res) => {
        if (res.code === 0) {
          // this.$nextTick(() => { this.$refs['templateForm'].resetFields() })
          const resData = res.data
          const tempObj = {
            name: resData.name, // 模板标题
            id: resData.id, // 模板标题
            content: resData.content, // 模板内容
            templateId: resData.templateId, // 模板
            signType: resData.signType, // 模板签名
            paramObj: resData.paramList[0]
          }
          if (resData.paramList[0] && resData.paramList[0].paramContent) {
            // tempObj['paramsKey'] = resData.paramList[0].paramContent
          }
          this.showDialog(oType)
          this.templateForm = resData
          // this.templateForm = tempObj
          console.log('this.templateForm', this.templateForm)
        } else {
          this.$message.success('刷新消息模板成功！')
          console.log('refreshTemplate - 失败', res)
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    showDialog (type, row) {
      let titleStr = '新增模版动作'
      if (type === 'edit') { titleStr = '编辑模版动作' }
      this.setCloseOrder = ''
      this.dialog.visible = true
      this.dialog.title = titleStr
      this.dialog.width = '640px'
      this.dialog.type = type
      // this.dialog.row = row
      if (type === 'add') {
        this.$nextTick(() => {
          this.templateForm = { name: '粉丝关注', templateId: '', signType: '', paramList: [{ paramType: '1', paramContent: '' }] }
          this.templateContent = ''
          this.$refs['templateForm'].resetFields()
        })
      }
    },
    centerDialog () {
      this.dialog.visible = false
      this.$message('已取消')
    },
    submitDialog () {
      this.$refs['templateForm'].validate((valid) => {
        if (valid) {
          for (let i = 0; i < this.templateForm.paramList.length; i++) {
           if (this.templateForm.paramList[i].paramContent === '') {
             return this.$message.warning('请完善参数内容！')
           }
          }
          this.saveJhyxMessageActionSetting()
          this.dialog.visible = false
        } else {
          this.$message.warning('请完善内容！')
        }
      });

      // this.$message.success('保存成功')
    },
    saveJhyxMessageActionSetting () {
      const params = Object.assign({}, this.templateForm)
      console.log('params', params)
      const type = this.dialog.type
      // params.paramList = []
      if (type === 'add') {
        // params.paramList.push({ paramContent: params.paramsKey, paramType: 1 })
        if (params.id) { params.id }
      }
      if (type === 'edit') {
        // const tempObj = this.templateForm.paramObj
        // tempObj['paramContent'] = params.paramsKey
        // params.paramList.push(tempObj)
        params.paramList.forEach(e => { e.jhyxSettingId = params.id })
      }
      params['content'] = ''
      params['paramNum'] = params.paramList.length
      this.$api.saveJhyxMessageActionSetting(params).then((res) => {
        if (res.code === 0) {
          this.$message.success('操作成功！')
          // this.siteInsideMsgSelectList()
          this.fetchMessageData()
          // console.log('allMiniTemplate - 成功', res)
        } else {
          console.log('allMiniTemplate - 失败', res)
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    siteInsideMsgEnable (sta) {
      // return console.log(this.templateForFans)
      const params = { id: this.templateForFans.id, status: sta === 1 ? 2 : 1 }
      this.$confirm('是否继续操作?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // return console.log(sta)
        this.$api.siteInsideMsgEnable(params).then((res) => {
          if (res.code === 0) {
            this.$message.success('操作成功！')
            this.siteInsideMsgSelectList()
            // console.log('allMiniTemplate - 成功', res)
          } else {
            console.log('allMiniTemplate - 失败', res)
          }
        }).catch((err) => {
          console.log(err)
        })
      }).catch((err) => {
        this.$message({
          type: 'info',
          message: '已取消操作'
        })
        return console.log('已取消操作', sta)
      })
    },
    siteInsideMsgSave () {
      // return console.log(this.templateForFans)
      const params = Object.assign({}, this.templateForFans)
      this.$api.siteInsideMsgSave(params).then((res) => {
        if (res.code === 0) {
          this.$message.success('操作成功！')
          // console.log('allMiniTemplate - 成功', res)
        } else {
          console.log('allMiniTemplate - 失败', res)
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    siteInsideMsgSelectList (type) {
      const params = { pageNo: 1, pageSize: 10 }
      this.$api.siteInsideMsgSelectList(params).then((res) => {
        if (res.code === 0) {
          this.templateForFans = res.data.list[0]
          // this.templateForFans.paramList[1].paramContent = this.templateForFans.paramList[1].paramContent
          // console.log('allMiniTemplate - 成功', this.templateForFans)
          if (type === 'opt') {
            this.$message.success('重置成功！')
          }
        } else {
          console.log('allMiniTemplate - 失败', res)
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    onChangeTempl (id) {
      const templateDataList = this.templateDataList
      const findTemplate = templateDataList.find(item => { return item.id === id })
      if (findTemplate) {
        const templateContent = findTemplate.content
        this.templateContent = templateContent
        const templateParamNum = findTemplate.paramNum
        const tempArr = []
        for (let index = 1; index <= templateParamNum; index++) {
          const obj = { paramType: '1', paramContent: '' }
          tempArr.push(obj)
        }
        this.templateForm.paramList = tempArr
      } else {
        this.templateContent = ''
      }

      console.log('paramList', this.templateForm.paramList)
    }
  }
}
</script>
<style scoped lang="scss">
@import "./manage.scss";
</style>
